import React, { memo } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AttributeTokens } from './AttributeTokens';
import { translateFunc } from '../../../Helpers/translateFunc';

const QrAccordion = ({ title, data, t }) => {
  return (
    <Box sx={{ marginTop: 3 }}>
      <Accordion
        sx={{
          marginY: 2,
          backgroundColor: 'background.default',
          boxShadow: theme => `0 0 10px ${theme.palette.primary.dark}99`,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h3" sx={{ color: 'primary.main' }}>
              {title}
            </Typography>
            {data.subLabel && (
              <Typography color="text.secondary" variant="body2">
                *{translateFunc(
                  t,
                  `basicFormStepByStep.placeholdersTranslate.${data.subLabel}`,
                  data.subLabel
                )}
              </Typography>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <AttributeTokens tt={t} data={data} hideLabel={true} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default memo(QrAccordion);
